import React, { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { AlertTriangle } from "lucide-react";

export default function IncidentDialog({ open, onOpenChange, detail, warehouses = [], onConfirm }) {
  const [form, setForm] = useState({ quantity: 1, reason: "", location_id: "" });
  useEffect(() => { if (open) setForm({ quantity: 1, reason: "", location_id: "" }); }, [open]);
  const locs = (detail?.locations || []).filter((l) => l.location_id);
  const submit = () => onConfirm({ quantity: parseInt(form.quantity) || 1, reason: form.reason.trim(), location_id: form.location_id || "" });
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="border-zinc-800 bg-zinc-950 text-white">
        <DialogHeader><DialogTitle className="flex items-center gap-2 text-white"><AlertTriangle className="h-5 w-5 text-[#FFD500]" />Ajouter un incident</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <p className="text-sm text-zinc-400">Retire définitivement des unités du stock de « {detail?.name} » (ex : enceinte cassée). Vous pourrez rétablir l'unité plus tard si elle est réparée.</p>
          <div><Label className="text-zinc-400">Nombre d'unités concernées</Label><Input data-testid="incident-qty" type="number" min={1} className="mt-1 border-zinc-800 bg-zinc-900" value={form.quantity} onChange={(e) => setForm({ ...form, quantity: e.target.value })} /></div>
          {locs.length > 0 && (
            <div>
              <Label className="text-zinc-400">Entrepôt concerné</Label>
              <Select value={form.location_id || "none"} onValueChange={(v) => setForm({ ...form, location_id: v === "none" ? "" : v })}>
                <SelectTrigger data-testid="incident-location" className="mt-1 border-zinc-800 bg-zinc-900"><SelectValue placeholder="Choisir" /></SelectTrigger>
                <SelectContent className="border-zinc-800 bg-zinc-900">
                  <SelectItem value="none">— Non précisé —</SelectItem>
                  {locs.map((l) => { const w = warehouses.find((x) => x.id === l.location_id); return <SelectItem key={l.location_id} value={l.location_id}>{w ? w.name : l.location_id}</SelectItem>; })}
                </SelectContent>
              </Select>
            </div>
          )}
          <div><Label className="text-zinc-400">Motif</Label><Textarea data-testid="incident-reason" placeholder="Ex : Enceinte cassée pendant le transport" className="mt-1 border-zinc-800 bg-zinc-900" value={form.reason} onChange={(e) => setForm({ ...form, reason: e.target.value })} /></div>
          <Button data-testid="incident-confirm" onClick={submit} className="w-full rounded-full bg-[#FF6A00] font-semibold text-white hover:bg-[#E65F00]">Enregistrer l'incident</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
